$(function(){
  var NCDialog = function(target, callbacks){
    var $wrapper = $('<div>').addClass('dialog_wrapper');
    $('body').append($wrapper.hide());
    var $target = $(target);
    $target.hide();
    this.$target = $target;
    this.$wrapper = $wrapper;
    var self = this;
    $.each(callbacks, function(key, val){
      self.$target.find('.dialog_'+key).on('click', val);
    });
  };
  NCDialog.prototype.close = function(){
    this.$target.hide();
    this.$wrapper.hide();
  };
  NCDialog.prototype.open = function(callbacks){
    this.$target.show();
    this.$wrapper.show();
  };

  var isMatchEmail = function($form){
    var email = $form.find('[name="email"]').val();
    var emailc = $form.find('[name="email-account"]').val() 
        + '@' + $form.find('[name="email-domain"]').val();
    return email == emailc;
  };

  var contactCb = function(e){
    e.preventDefault();
    var $form = $(this);
    if(checkForm($form)){
      var $button = $(this).find('button, input[type="submit"]');
      var loading = new NCDialog('.loading');
      var token = '';
      loading.open();
      $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: $form.serialize(),
        timeout: 10000,
        beforeSend: function(xhr, settings) {
          $button.prop('disabled', true);
        },
        complete: function(xhr, textStatus) {
          loading.close();
          $button.prop('disabled', false);
        },
        success: function(res, textStatus, xhr) {
          if(res.result == 0){
            location.href = '/send-complete.html';
          }else if(res.result == 1){
            $form.find('.m-form--warn').removeClass('m-form--warn');
            var $mesArea = $('.popup-dialog_message').empty();
            $.each(res.invalid, function(k, v){
              var $elem = $form.find('[name="'+k+'"]');
              $elem.addClass('m-form--warn');
              $mesArea.append(
                $('<div>').append(v)
              );
            });
            var dialog = new NCDialog('.popup-dialog', {
              'yes': function(){
                dialog.close();
              }
            });
            dialog.open();
          }else{
            alert('送信に失敗しました。');
          }
        },
        error: function(xhr, textStatus, error) {
          alert('送信に失敗しました。');
        }
      });
    }
  };

  var checkForm = function($form){
    $form.find('.m-form--warn').removeClass('m-form--warn');

    var error = [];
    switch($form.find('[name="type"]').val()){
      case 'trial':
        var required = {
          "name": "お名前は必須項目です。",
          "email": "メールアドレスは必須項目です。",
          "phone": "電話番号は必須項目です。",
          "company-name": "会社名は必須項目です。"
        };
        $.each(required, function(k, v){
          var $elem = $form.find('[name="'+k+'"]');
          if($elem.val() == ''){
            $elem.addClass('m-form--warn');
            error.push(v);
          }
        });
        var $elem = $form.find('[name="application[]"]');
        var values = $form.serializeArray();
        var hasAppli = false;
        $.each(values, function(idx){
          var obj = values[idx];
          if(obj.name == 'application[]'){
            hasAppli = true;
          }
        });
        if(!hasAppli){
          $('[name="application[]"]').addClass('m-form--warn');
          error.push('アプリの種類は必須項目です。');
        }
        $elem = $form.find('[name="privacy-policy"]');
        if(!$elem.is(':checked')){
          $elem.addClass('m-form--warn');
          error.push('プライバシーポリシーへの同意が必要です。');
        }
        break;
      case 'us':
        var required = {
          "name": "お名前は必須項目です。",
          "email": "メールアドレスは必須項目です。",
          "content": "お問い合わせ内容は必須項目です。"
        };
        $.each(required, function(k, v){
          var $elem = $form.find('[name="'+k+'"]');
          if($elem.val() == ''){
            $elem.addClass('m-form--warn');
            error.push(v);
          }
        });
        var $elem = $form.find('[name="privacy-policy"]');
        if(!$elem.is(':checked')){
          $elem.addClass('m-form--warn');
          error.push('プライバシーポリシーへの同意が必要です。');
        }
        break;
      case 'mobile':
        var $elem = $form.find('[name="email"]');
        if($elem.val() == ''){
          $elem.addClass('m-form--warn');
          error.push("メールアドレスは必須項目です。");
        }
        var $elem = $form.find('[name="privacy-policy"]');
        if(!$elem.is(':checked')){
          $elem.addClass('m-form--warn');
          error.push('プライバシーポリシーへの同意が必要です。');
        }
        break;
    }
    if(error.length == 0 && isMatchEmail($form)){
      return true;
    }
    
    var $mesArea = $('.popup-dialog_message').empty();
    $.each(error, function(k, v){
      $mesArea.append(
        $('<div>').append(v)
      );
    });
    if(!isMatchEmail($form)){
      $form.find('[name="email-account"]').addClass('m-form--warn');
      $form.find('[name="email-domain"]').addClass('m-form--warn');
      $mesArea.append(
        $('<div>').append('メールアドレスが確認用と一致しません。')
      );
    }
    var dialog = new NCDialog('.popup-dialog', {
      'yes': function(){
        dialog.close();
      }
    });
    dialog.open();
    return false;
  };
  $('#contact-trial').submit(contactCb);
  $('#contact-us').submit(contactCb);
  $('#contact-mobile').submit(contactCb);
});

